import React from "react";
import ProcessSteps from "@/components/ProcessSteps";

export default function HomeProcessSection() {
  return (
    <section className="section-pad bg-white">
      <div className="container-br">
        <div className="max-w-2xl mb-8">
          <div className="br-eyebrow">Our Process</div>
          <h2 className="br-headline text-3xl sm:text-4xl mt-3">Five Steps. No Surprises.</h2>
        </div>
        <ProcessSteps />
      </div>
    </section>
  );
}
